export const DISPOSITION_INITIALIZE_SAGA = "DISPOSITION_INITIALIZE_SAGA";
export const DISPOSITION_SET_DEFAULT_FILTER_SAGA =
    "DISPOSITION_SET_DEFAULT_FILTER_SAGA";
export const DISPOSITION_SET_FILTER = "DISPOSITION_SET_FILTER";
export const DISPOSITION_SET_DEFAULT_VALUES_SAGA =
    "DISPOSITION_SET_DEFAULT_VALUES_SAGA";
export const DISPOSITION_SET_DEFAULT_VALUES = "DISPOSITION_SET_DEFAULT_VALUES";

export const INITIALIZE_SUCCESS = "@DISPO/INITIALIZE_SUCCESS";
export const INITIALIZE_FAILED = "@DISPO/INITIALIZE_FAILED";

export const FETCHING_DATA_START = "@DISPO/FETCHING_DATA_START";
export const FETCHING_DATA_FAILED = "@DISPO/FETCHING_DATA_FAILED";
export const CLEAR_FETCHING_DATA_FAILED = "@DISPO/CLEAR_FETCHING_DATA_FAILED";

export const RENDER = "@DISPO/RENDER";
export const COMPILE_DISPOSITION_DATA = "@DISPO/COMPILE_DATA";

export const CHANGE_STATION = "@DISPO/CHANGE_STATION";
export const CHANGE_STATION_START = "@DISPO/CHANGE_STATION_START";

export const MOVE_BOOKING = "@DISPO/MOVE_BOOKING";
export const FETCH_BOOKING = "@DISPO/FETCH_BOOKING";
export const FETCH_BOOKING_SUCCESS = "@DISPO/FETCH_BOOKING_SUCCESS";

export const CHANGE_DATES_START = "@DISPO/CHANGE_DATES_START";
export const CHANGE_DATES = "@DISPO/CHANGE_DATES";
export const SET_FILTER = "@DISPO/SET_FILTER";

export const TOGGLE_STATION = "@DISPO/TOGGLE_STATION";
export const TOGGLE_VEHICLES_IN_STATION = "@DISPO/TOGGLE_VEHICLES_IN_STATION";
export const TOGGLE_HIDE_UNAVAILABLE_VEHICLES =
    "@DISPO/TOGGLE_HIDE_UNAVAILABLE_VEHICLES";

export const DISPO_SEARCH = "@DISPO/SEARCH";

export const OPEN_VEHICLE_INFO = "@DISPO/OPEN_VEHICLE_INFO";
export const OPEN_STATION_INFO = "@DISPO/OPEN_STATION_INFO";
export const OPEN_BOOKING_INFO = "@DISPO/OPEN_BOOKING_INFO";

export const CLOSE_VEHICLE_INFO = "@DISPO/CLOSE_VEHICLE_INFO";
export const CLOSE_STATION_INFO = "@DISPO/CLOSE_STATION_INFO";
export const CLOSE_BOOKING_INFO = "@DISPO/CLOSE_BOOKING_INFO";

export const DISPOSITION_RESET_FILTER_SAGA = "DISPOSITION_RESET_FILTER_SAGA";

export const CLEAR = "CLEAR";
export const CLEAR_DATA = "CLEAR_DATA";

export const TOGGLE_ARRIVING_VEHICLES = "TOGGLE_ARRIVING_VEHICLES";

export const DISPOSITION_UPDATE_AUTODISPO_STATUS_SAGA =
    "DISPOSITION_UPDATE_AUTODISPO_STATUS_SAGA";
export const DISPOSITION_RESET_SHOW_ONLY_GROUP_RES_OF_STATION_FILTER =
    "DISPOSITION_RESET_SHOW_ONLY_GROUP_RES_OF_STATION_FILTER";

export const RESERVATION_LOG_INITIALIZE_SAGA =
    "RESERVATION_LOG_INITIALIZE_SAGA";
export const FETCHING_RESERVATION_LOG_DATA_START =
    "FETCHING_RESERVATION_LOG_DATA_START";
export const FETCHING_RESERVATION_LOG_DATA = "FETCHING_RESERVATION_LOG_DATA";
export const FETCHING_RESERVATION_LOG_DATA_SUCCESS =
    "FETCHING_RESERVATION_LOG_DATA_SUCCESS";
export const CHANGE_SHOWBEFORE_RESERVATION_LOG_START =
    "CHANGE_SHOWBEFORE_RESERVATION_LOG_START";
export const CHANGE_SHOWBEFORE_RESERVATION_LOG =
    "CHANGE_SHOWBEFORE_RESERVATION_LOG";
export const CHANGE_SHOWAFTER_RESERVATION_LOG_START =
    "CHANGE_SHOWAFTER_RESERVATION_LOG_START";
export const CHANGE_SHOWAFTER_RESERVATION_LOG =
    "CHANGE_SHOWAFTER_RESERVATION_LOG";
export const CHANGE_ALLSTATIONS_RESERVATION_LOG =
    "CHANGE_ALLSTATIONS_VEHICLE_LOG";
export const CHANGE_ALLSTATIONS_RESERVATION_LOG_START =
    "CHANGE_ALLSTATIONS_RESERVATION_LOG_START";
export const DISPOSITION_RESERVATION_LOG_FETCH_DATA =
    "DISPOSITION_RESERVATION_LOG_FETCH_DATA";
export const DISPOSITION_VEHICLE_LOG_FETCH_DATA =
    'DISPOSITION_VEHICLE_LOG_FETCH_DATA'
export const CHANGE_DELIVERY_VEHICLE_LOG =
    'CHANGE_DELIVERY_VEHICLE_LOG'
export const CHANGE_DELIVERY_VEHICLE_LOG_START =
    'CHANGE_DELIVERY_VEHICLE_LOG_START'
export const CHANGE_PICKUPPLANNED_VEHICLE_LOG =
    'CHANGE_PICKUPPLANNED_VEHICLE_LOG'
export const CHANGE_PICKUPPLANNED_VEHICLE_LOG_START =
    'CHANGE_PICKUPPLANNED_VEHICLE_LOG_START'
export const CHANGE_PICKUPCONFIRMED_VEHICLE_LOG =
    'CHANGE_PICKUPCONFIRMED_VEHICLE_LOG'
export const CHANGE_PICKUPCONFIRMED_VEHICLE_LOG_START =
    'CHANGE_PICKUPCONFIRMED_VEHICLE_LOG_START'
export const CHANGE_FROMSTATION_VEHICLE_LOG =
    'CHANGE_FROMSTATION_VEHICLE_LOG'
export const CHANGE_FROMSTATION_VEHICLE_LOG_START =
    'CHANGE_FROMSTATION_VEHICLE_LOG_START'
export const CHANGE_TOSTATION_VEHICLE_LOG =
    'CHANGE_TOSTATION_VEHICLE_LOG'
export const CHANGE_TOSTATION_VEHICLE_LOG_START =
    'CHANGE_TOSTATION_VEHICLE_LOG_START'
export const CHANGE_WITHOUTDELIVERED_VEHICLE_LOG =
    'CHANGE_WITHOUTDELIVERED_VEHICLE_LOG'
export const CHANGE_WITHOUTDELIVERED_VEHICLE_LOG_START =
    'CHANGE_WITHOUTDELIVERED_VEHICLE_LOG_START'
export const CHANGE_ALLSTATIONS_VEHICLE_LOG =
    'CHANGE_ALLSTATIONS_VEHICLE_LOG'
export const CHANGE_ALLSTATIONS_VEHICLE_LOG_START =
    'CHANGE_ALLSTATIONS_VEHICLE_LOG_START'
export const VEHICLE_LOG_SET_DEFAULT_FILTER_SAGA =
    'VEHICLE_LOG_SET_DEFAULT_FILTER_SAGA'
export const VEHICLE_LOG_SET_FILTER =
    'VEHICLE_LOG_SET_FILTER'
export const VEHICLE_LOG_SET_DEFAULT_VALUES_SAGA =
    'VEHICLE_LOG_SET_DEFAULT_VALUES_SAGA'
export const VEHICLE_LOG_SET_DEFAULT_VALUES =
    'VEHICLE_LOG_SET_DEFAULT_VALUES'
export const VEHICLE_LOG_INITIALIZE_SAGA =
    'VEHICLE_LOG_INITIALIZE_SAGA'
export const FETCHING_VEHICLE_LOG_DATA_START =
    'FETCHING_VEHICLE_LOG_DATA_START'
export const FETCHING_VEHICLE_LOG_DATA_SUCCESS =
    'FETCHING_VEHICLE_LOG_DATA_SUCCESS'
export const CHANGE_SHOWBEFORE_VEHICLE_LOG =
    'CHANGE_SHOWBEFORE_VEHICLE_LOG'
export const CHANGE_SHOWBEFORE_VEHICLE_LOG_START =
    'CHANGE_SHOWBEFORE_VEHICLE_LOG_START'
export const CHANGE_SHOWAFTER_VEHICLE_LOG =
    'CHANGE_SHOWAFTER_VEHICLE_LOG'
export const CHANGE_SHOWAFTER_VEHICLE_LOG_START =
    'CHANGE_SHOWAFTER_VEHICLE_LOG_START'
export const CLEAR_RESERVATION_LOG_DATA =
    "CLEAR_RESERVATION_LOG_DATA";
export const FETCHING_RESERVATION_LOG_DATA_FAILED =
    "FETCHING_RESERVATION_LOG_DATA_FAILED";
export const CLEAR_FETCHING_RESERVATION_LOG_DATA_FAILED =
    "CLEAR_FETCHING_RESERVATION_LOG_DATA_FAILED";
export const CLEAR_VEHICLE_LOG_DATA =
    "CLEAR_VEHICLE_LOG_DATA";
export const SET_SINGLE_DAY_PREVIOUS_STARTDATE = "SET_SINGLE_DAY_PREVIOUS_STARTDATE";
export const SET_SINGLE_DAY_PREVIOUS_STARTDATE_START = "SET_SINGLE_DAY_PREVIOUS_STARTDATE_START";
